export const JWT_TOKEN_REFRESH_INTERVAL = 60;
export const CONTEXT_RESOURCE_TYPE = {
  ALBUM: 'album',
  EVENT: 'event',
} as const;
